import api from './api';

export const comprovanteService = {
  // Upload de comprovantes para um pedido
  uploadComprovantes: async (pedidoId, files) => {
    try {
      const formData = new FormData();
      
      // Adicionar cada arquivo ao FormData
      Array.from(files).forEach(file => {
        formData.append('comprovantes', file);
      });

      const response = await api.post(`/pedidos/${pedidoId}/comprovantes`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      console.error('Erro ao fazer upload de comprovantes:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erro ao enviar comprovantes'
      };
    }
  },

  // Buscar comprovantes de um pedido
  getComprovantes: async (pedidoId) => {
    try {
      const response = await api.get(`/pedidos/${pedidoId}/comprovantes`);
      return {
        success: true,
        data: response.data.data || []
      };
    } catch (error) {
      console.error('Erro ao buscar comprovantes:', error);
      return {
        success: false,
        data: [],
        message: error.response?.data?.message || 'Erro ao carregar comprovantes'
      };
    }
  },

  // Remover comprovante
  removeComprovante: async (comprovanteId) => {
    try {
      const response = await api.delete(`/pedidos/comprovantes/${comprovanteId}`);
      return {
        success: true,
        message: response.data.message
      };
    } catch (error) {
      console.error('Erro ao remover comprovante:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erro ao remover comprovante'
      };
    }
  },

  // Obter URL do comprovante para visualização
  getComprovanteUrl: (nomeArquivo) => {
    const baseUrl = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
      ? 'http://localhost:3001/api'
      : 'https://api.ibe.elshadaysystems.com.br/api';
    return `${baseUrl}/pedidos/comprovantes/arquivo/${nomeArquivo}`;
  },

  // Obter imagem como blob autenticado
  getComprovanteBlob: async (nomeArquivo) => {
    try {
      // Validar se nomeArquivo é válido
      if (!nomeArquivo || nomeArquivo === 'undefined' || nomeArquivo === 'null') {
        console.warn('Nome de arquivo inválido:', nomeArquivo);
        return null;
      }

      const response = await api.get(`/pedidos/comprovantes/arquivo/${nomeArquivo}`, {
        responseType: 'blob'
      });
      return URL.createObjectURL(response.data);
    } catch (error) {
      console.error('Erro ao obter imagem:', error);
      return null;
    }
  },

  // Validar arquivos antes do upload
  validateFiles: (files) => {
    const maxSize = 2 * 1024 * 1024; // 2MB
    const maxFiles = 4;
    const allowedTypes = [
      'image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp',
      'application/pdf'
    ];

    const errors = [];

    if (files.length > maxFiles) {
      errors.push(`Máximo de ${maxFiles} arquivos permitidos`);
    }

    for (const file of files) {
      if (file.size > maxSize) {
        errors.push(`Arquivo "${file.name}" excede o tamanho máximo de 2MB`);
      }

      if (!allowedTypes.includes(file.type)) {
        errors.push(`Arquivo "${file.name}" deve ser imagem (JPG, PNG, GIF, WEBP) ou PDF`);
      }
    }

    return {
      isValid: errors.length === 0,
      errors
    };
  },

  // Detecta se um comprovante é PDF (pelo mime ou pela extensão).
  isPdf: (comprovante) => {
    if (!comprovante) return false;
    if (comprovante.tipoMime === 'application/pdf') return true;
    const nome = comprovante.nomeArquivo || comprovante.nomeOriginal || '';
    return /\.pdf$/i.test(nome);
  },

  // Formatar tamanho do arquivo
  formatFileSize: (bytes) => {
    if (bytes === 0) return '0 Bytes';
    
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }
};
